export default __webpack_public_path__ + "static/media/about.632b545f.svg";